import { inject, Injectable } from '@angular/core';
import { Service } from '../interfaces/service.interface';
import { Router } from '@angular/router';
import { EnvService } from '../services/env.service';
import { Store } from '@ngrx/store';
import { LoggerService } from '../services/logger.service';

@Injectable()
export abstract class AbstractService implements Service {
  protected readonly logger = inject(LoggerService, { host: true });
  protected readonly store = inject(Store);
  protected readonly router: Router = inject(Router);
  protected readonly env: EnvService = inject(EnvService);

  get name(): string {
    return this.constructor.name;
  }
}
